// Workspace-scoped endpoints

export const createUploadRequest = (contentType, fileName) => ({
  url: "/media",
  method: "POST",
  data: { content_type: contentType, file_name: fileName },
});

export const createConfirmUploadRequest = (id) => ({
  url: `/media/${id}/confirm`,
  method: "POST",
});

export const createListMediaRequest = (mediaType, page = 1, perPage = 20) => ({
  url: "/media",
  method: "GET",
  params: {
    media_type: mediaType || undefined,
    page,
    per_page: perPage,
  },
});

export const createGetMediaRequest = (id) => ({
  url: `/media/${id}`,
  method: "GET",
});

export const createDeleteMediaRequest = (id) => ({
  url: `/media/${id}`,
  method: "DELETE",
});

// Org-scoped endpoints

export const createOrgUploadRequest = (workspaceId, contentType, fileName) => {
  // workspace_id is optional on the BE. When omitted, the upload becomes an
  // org-level asset (workspace_id IS NULL, org_id set) and shows up in the
  // default "All workspaces" library view.
  const data = { content_type: contentType, file_name: fileName };
  if (workspaceId) data.workspace_id = workspaceId;
  return { url: "/orgs/media", method: "POST", data };
};

export const createOrgConfirmUploadRequest = (id) => ({
  url: `/orgs/media/${id}/confirm`,
  method: "POST",
});

export const createOrgListMediaRequest = (workspaceIds, mediaType, page = 1, perPage = 20) => ({
  url: "/orgs/media",
  method: "GET",
  params: {
    workspace_ids: workspaceIds || undefined,
    media_type: mediaType || undefined,
    page,
    per_page: perPage,
  },
});

export const createOrgGetMediaRequest = (id) => ({
  url: `/orgs/media/${id}`,
  method: "GET",
});

export const createOrgDeleteMediaRequest = (id) => ({
  url: `/orgs/media/${id}`,
  method: "DELETE",
});

export const createOrgCopyMediaRequest = (id, targetWorkspaceId) => ({
  url: `/orgs/media/${id}/copy`,
  method: "POST",
  data: { target_workspace_id: targetWorkspaceId },
});
